<template>
    <div id="advertisement">
        <c-body class="c-body">
            <div slot="before-header">
                <!-- <Tabs :value="currentTab" @on-click="onClickTab" class="tab-moudle">
                    <TabPane label="广告系列" name="adv-series"></TabPane>
                    <TabPane label="广告组" name="adv-group"></TabPane>
                    <TabPane label="广告" name="adv-item"></TabPane>
                </Tabs> -->
                <el-tabs class="tab-moudle" type="card" :value="currentTab" @tab-click="onClickTab">
                    <el-tab-pane label="广告系列" name="adv-series">
                        <span slot="label"><span>广告系列</span><span class="label_active" v-if="Selection_series > 0">已选{{Selection_series}}项<i  @click="fun_closeNum('Selection_series','adv-series')" class="el-icon-circle-close"></i></span></span>
                    </el-tab-pane>
                    <el-tab-pane label="广告组" name="adv-group">
                        <span slot="label"><span>广告组</span><span class="label_active" v-if="Selection_Campaign > 0">已选{{Selection_Campaign}}项<i  @click="fun_closeNum('Selection_Campaign','adv-group')" class="el-icon-circle-close"></i></span></span>
                    </el-tab-pane>
                    <el-tab-pane label="广告" name="adv-item"></el-tab-pane>
                    </el-tabs>

            </div>
            <div slot="section">
                <router-view ref="adv_Page" @onClickTab="onClickTab" @screenNum="fun_screenNum"></router-view>
            </div>
        </c-body>
    </div>
    </template>
    <script>
    import cBody from '@/components/commons/cBody.vue';
    export default {
        name: 'Advertisement',
        components: {
            cBody
        },
        computed: {
            currentTab() {
                return this.$route.name;
            },
            // Selection_series(){
            //     return JSON.parse(sessionStorage.getItem('Selection_series')).length || 0
            // },  
        },
        data(){
            return{
                Selection_series:0,
                Selection_Campaign:0,
            }
        },
        mounted(){
            this.Selection_series = sessionStorage.getItem('Selection_series') ? JSON.parse(sessionStorage.getItem('Selection_series')).length : 0
            this.Selection_Campaign = sessionStorage.getItem('Selection_Campaign') ? JSON.parse(sessionStorage.getItem('Selection_Campaign')).length : 0
        },  
          
        methods: {
            /*
             * @description 点击tab，切换导航
             * @param link:string 路由地址
             */
            onClickTab(link) {
                console.log('this.$route.name',this.$route.name)
                console.log('link.name',link.name)
                if(this.$route.name == link.name && this.$route.name == 'adv-series'){
                    sessionStorage.setItem('Selection_series',[])
                    this.$refs.adv_Page.Fun_Selection_cleos()
                    // this.$refs.adv_Page.getList(false)
                    return
                }
                if(this.$route.name == link.name && this.$route.name == 'adv-group'){
                    sessionStorage.setItem('Selection_group',[])
                    this.$refs.adv_Page.Fun_Selection_cleos()
                    // this.$refs.adv_Page.getCampaignList(false)
                    return
                }
                // 无效排序返回
                this.$router.push({ name: link.name });
            },
            fun_screenNum(obj,Num){
                console.log('data',obj,Num)
                this[obj] = Num
            },
            fun_closeNum(name,currentTab){
                if(currentTab == this.currentTab){
                    sessionStorage.setItem(name,[])
                    this[name] = 0
                }
            }
        }
    };
    </script>

    <style lang="less" scoped>
        /deep/.tab-moudle{
            .el-tabs__nav{
                border:none !important;
                .el-tabs__item{
                    &:hover{color:#23c52f;}
                    border:none;
                    font-size:16px;
                    padding:0 20px !important;
                    
                }
                .is-active{
                    color:#23c52f;
                    border-bottom:1px solid #23c52f !important;
                }
             }
             .label_active{
                border:1px solid #23c52f;
                margin-left:12px;
                padding:0px 4px;
                border-radius:3px;
                color:#23c52f;
                font-size:12px;
                i{
                 padding-left:6px;
                }
             }
        }
    </style>


// WEBPACK FOOTER //
// src/view/PromotionManagement/PromotionManagement.vue